<div class="back-btn" (click)="onBack()"></div>
<section class="link-tv-container vertical-ac focusable-container">
  <app-icon [icon]="'aha-logo'" class="header__logo"></app-icon>
  <button
    class="back-btn-wrapper horizontal-ac focusable-element"
    (click)="onBack()"
    (focusin)="isFocused = true"
    (focusout)="isFocused = false"
  >
    <app-icon
      [icon]="'back'"
      [isFocused]="isFocused"
      class="back-btn-icon"
    ></app-icon>
    <span class="back-btn-text" [style]="'fontSize.20' | translate">{{
      "back" | translate
    }}</span>
  </button>
  <div class="link-tv-content vertical-ac">
    <h1
      [innerHTML]="'link_tv_title' | translate"
      [style]="'fontSize.48' | translate"
    ></h1>
    <div class="horizontal-ac link-tv-content-wrapper">
      <div class="link-tv-content-wrapper-left vertical-ac">
        <h2
          [innerHTML]="'scan_qr_to_link_tv' | translate"
          [style]="'fontSize.35' | translate"
        ></h2>
        <div class="steps-container horizontal-ac">
          <div
            class="step-item vertical-ac"
            *ngFor="let step of STEPS; trackBy: trackByStepId"
          >
            <div class="step-item-bg">
              <h2 class="step-item-number" [style]="'fontSize.36' | translate">
                {{ step.id }}
              </h2>
            </div>
            <p
              class="step-item-title"
              [style]="'fontSize.20' | translate"
              [innerHTML]="getLeftSteps(step) | translate"
            ></p>
          </div>
          <div class="link-tv-content-wrapper-right-line"></div>
        </div>
        <div class="qr-code-wrapper">
          <ngx-kjua
            [text]="loginCode"
            [render]="'canvas'"
            [fill]="'#000000'"
            [back]="'transparent'"
            [quiet]="1"
            [size]="qrSize"
          >
          </ngx-kjua>
        </div>
      </div>
      <div class="link-tv-content-wrapper-middle vertical-ac">
        <div class="vertical-line"></div>
        <p [style]="'fontSize.26' | translate">{{ "caps_or" | translate }}</p>
        <div class="vertical-line"></div>
      </div>

      <div class="link-tv-content-wrapper-right vertical-ac">
        <h2
          class="link-tv-content-wrapper-right-title"
          [style]="'fontSize.35' | translate"
        >
          <span [innerHTML]="'enter_code_to_link_tv' | translate"></span>
        </h2>
        <div class="steps-container horizontal-ac">
          <div
            class="step-item vertical-ac"
            *ngFor="let step of STEPS; trackBy: trackByStepId"
          >
            <div class="step-item-bg">
              <h2 class="step-item-number" [style]="'fontSize.36' | translate">
                {{ step.id }}
              </h2>
            </div>
            <p
              class="step-item-title"
              [innerHTML]="step.title | translate"
              [style]="'fontSize.20' | translate"
            ></p>
          </div>
          <div class="link-tv-content-wrapper-right-line"></div>
        </div>
        <div class="link-tv-content-wrapper-right-icon-wrapper">
          <div class="link-tv-content-wrapper-right-icon-wrapper-mobile">
            <app-icon
              [icon]="'mobile-wrapper'"
              class="link-tv-content-wrapper-right-icon"
            ></app-icon>
            <div
              class="link-tv-content-wrapper-right-icon-wrapper-bg-text vertical-ac"
            >
              <p
                [innerHTML]="'enter_code_label' | translate"
                [style]="'fontSize.22' | translate"
              ></p>
              <h3 [style]="'fontSize.60' | translate">{{ loginCode }}</h3>
            </div>
          </div>
        </div>
        <div class="link-tv-content-wrapper-right-text vertical-ac">
          <p
            [innerHTML]="'or_visit_label' | translate"
            [style]="'fontSize.22' | translate"
          ></p>
          <h3 [style]="'fontSize.26' | translate">www.aha.video/activate</h3>
        </div>
      </div>
    </div>
  </div>
  <p class="code-auto-refresh-text" [style]="'fontSize.20' | translate">
    {{ "auto_refresh_message" | translate }}
  </p>
</section>
